import axios from "axios";
import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import Swal from "sweetalert2";
import useUserInformation from "../../../hooks/useUserInformation";
import Loading from "../../../modules/public/loading/loading";
import baseUrl from "../../../modules/utility/baseUrl";

function TokenLogin() {
  const params = useParams();
  const { setToken, setStorage } = useUserInformation();

  const sendData = () => {
    const token = params.token;

    axios
      .get(`${baseUrl}/user/v1/loginAgentWithToken`, {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: "Bearer " + token,
        },
      })
      .then(res => {
        setToken(res.data.token);
        setStorage(
          {
            user: res.data.user,
            agent: res.data.user.agent,
          },
          true,
        );
        window.location.href = "/";
      })
      .catch(error => {
        Swal.fire({
          title: error?.response?.data?.data ?? "خطای ارتباط با سرور",
          icon: "error",
          dangerMode: true,
          confirmButtonText: "متوجه شدم",
          confirmButtonColor: "red",
        }).then(() => (window.location.href = "/login"));
      });
  };

  useEffect(() => {
    window.localStorage.clear();
    window.sessionStorage.clear();
    sendData();
  }, []);

  return <Loading />;
}

export default TokenLogin;
